/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_ListUniversitiesRow } from '../models/db_ListUniversitiesRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Universities {
    /**
     * Get a list of universities
     * @param programmes Programmes
     * @returns db_ListUniversitiesRow OK
     * @throws ApiError
     */
    public static listUniversities(
        programmes?: string,
    ): CancelablePromise<Array<db_ListUniversitiesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/universities',
            query: {
                'programmes': programmes,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
